import { render } from "./BrandDeactivateModalContent.vue?vue&type=template&id=2bb19f80"
import script from "./BrandDeactivateModalContent.vue?vue&type=script&lang=js"
export * from "./BrandDeactivateModalContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/BrandDeactivateModalContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2bb19f80"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2bb19f80', __exports__)) {
    api.reload('2bb19f80', __exports__)
  }
  
  module.hot.accept("./BrandDeactivateModalContent.vue?vue&type=template&id=2bb19f80", () => {
    api.rerender('2bb19f80', render)
  })

}


export default __exports__